import FundType from "./FundType";

export default class FundTypeObj {
	public tipofondos: FundType = new FundType();
	public usuarios: any = {};
}